import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import useApi from "../../helpers/apiHelper/requestHelper";
import { showNotificationToast, toastify } from "../../helpers/toast/toastify";
import { setRefetchSpecificUser } from "../../redux/multicommunity/multicommunity";
import { useDispatch, useSelector } from "react-redux";
import crossBlack from "../../assets/images/onboardingImages/crossBlack.svg";
import logo_black from "../../assets/images/onboardingImages/logo_black.svg";
import { Modal } from "react-bootstrap";
import BubbleSvgButton from "../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { selectedRowsforVerifyMyTrade } from "../../store/globalstore";
import { useAtom } from "jotai";

const VerifyTradeResult = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [paymentVerified, setPaymentVerified] = useState(false);
  const [blockchainApiCalled, setBlockchainApiCalled] = useState(false);
  const { user } = useSelector((state) => state.user);
  const [selectedRowsForStatsCalculation, setSelectedRowsForStatsCalculation] =
    useAtom(selectedRowsforVerifyMyTrade);
  const api = useApi();

  const sessionId = searchParams.get("session_id");

  const sendUserDataOnBlockChain = async () => {
    try {
      setBlockchainApiCalled(true);

      const response=await api("post", "blocakChain/sendSelectedStatsOnBlockChain", {
        selectedTrades: selectedRowsForStatsCalculation,
      });
      setSelectedRowsForStatsCalculation([]);
      // showNotificationToast("Trade(s) verified!", `Here's the link ${response?.data?.blockchainInfo?.blockChainUrl}`);
      setLoading(false);
      dispatch(setRefetchSpecificUser(true));
      console.log("Successfully sent to blockchain API",response);
    } catch (error) {
      setSelectedRowsForStatsCalculation([]);
      console.log("Error sending to blockchain:", error);
    }
  };

  useEffect(() => {
    const checkPaymentStatus = async () => {
      try {
        setLoading(true);
        const response = await api(
          "get",
          `users/verifyTradeCheckoutOneTime?session_id=${sessionId}`
        );

        if (response?.status && response.data.paid) {
          setPaymentVerified(true);
          toastify("You’re subscribed and performance will be verified.");
        } else {
          setLoading(false);
          toastify("Payment not completed or failed.");
        }
      } catch (error) {
        setLoading(false);
        console.error("Payment check failed:", error);
        toastify("Something went wrong");
      }
    };

    if (sessionId) checkPaymentStatus();
  }, [sessionId]);

  useEffect(() => {
    const handleBlockchainCall = async () => {
      if (
        paymentVerified &&
        selectedRowsForStatsCalculation &&
        selectedRowsForStatsCalculation.length > 0
      ) {
        await sendUserDataOnBlockChain();
      } else if (paymentVerified) {
        console.log("Payment verified but waiting for selectedTrades...", {
          hasArray: !!selectedRowsForStatsCalculation,
          arrayLength: selectedRowsForStatsCalculation?.length || 0,
        });
      }
    };

    handleBlockchainCall();
  }, [paymentVerified, selectedRowsForStatsCalculation]);

  // Fallback mechanism - if payment is verified but selectedTrades is still empty after 10 seconds
  useEffect(() => {
    if (paymentVerified && !blockchainApiCalled) {
      const fallbackTimer = setTimeout(() => {
        if (
          !blockchainApiCalled &&
          (!selectedRowsForStatsCalculation ||
            selectedRowsForStatsCalculation.length === 0)
        ) {
          console.warn(
            "Fallback: selectedTrades still empty after 10 seconds, proceeding anyway..."
          );
          setLoading(false);
          toastify(
            "Warning: No trades selected for blockchain verification",
            "warning"
          );
        }
      }, 10000);

      return () => clearTimeout(fallbackTimer);
    }
  }, [paymentVerified, selectedRowsForStatsCalculation, blockchainApiCalled]);

  const handleClose = () => {
    navigate("/leader/dashboard");
  };

  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal"
        show={true}
      >
        <Modal.Body
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingBottom: "130px",
          }}
        >
          <button className="CrossIcon" onClick={handleClose} type="button">
            <img alt="" src={crossBlack} />
          </button>

          <div>
            {loading && (
              <p>Your last 7 days stats are sending on block chain </p>
            )}
            {!loading && (
              <div
                style={{
                  marginBottom: "50px",
                }}
              >
                <span
                  style={{
                    fontFamily: "Graphik Medium",
                    fontSize: "16px",
                  }}
                >
                  see logs from this link
                </span>

                {user?.blockChainLink && (
                  <a
                    style={{
                      marginTop: "5px",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                      fontFamily: "Graphik Regular",
                      fontSize: "14px",
                    }}
                    href={user.blockChainLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {user.blockChainLink}
                  </a>
                )}

                <span
                  style={{
                    fontFamily: "Graphik Medium",
                    fontSize: "16px",
                    marginBottom: "10px",
                  }}
                >
                  Bloack Chain Public Id
                </span>
                <p>{user?.blockChainId}</p>
              </div>
            )}

            <BubbleSvgButton
              onClick={handleClose}
              text={"Next"}
              type="button"
              variant="black"
              containerStyling={{
                justifyContent: "center",
              }}
              mainDivStyle={{
                width: "250px",
                height: "auto",
              }}
            />
          </div>

          <div className="paginationDots">
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot active"></button>
          </div>
          <div className="copyrightBox">
            <p>
              Powered by
              <span className="spanMain">
                <img alt="" src={logo_black} />
              </span>
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default VerifyTradeResult;
